export default __webpack_public_path__ + "media/zurb/img/ecommerce/bn_2-c5e2a0cfdd2533889eb5858bfff4be5f.png";